import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";
import {AxiosResponse} from "axios";
import {
  BaseMutationOptions,
  BaseQueryOptions,
  BaseUseMutationResult,
  BaseUseQueryResult,
  useBaseMutation,
  useBaseQuery,
} from "@bounce/shared/requests";
import {UserCommunicationPreferences} from "@bounce/shared/consumer/declarations";

type Variables = {};

type Data = UserCommunicationPreferences;

export const getCommunicationPreferences = async (variables: Variables): Promise<Data> => {
  const result = await axiosConsumerAppInstance.get<Data, AxiosResponse<Data>>(`/user/communication_preferences`);
  return result.data;
};

export const useGetCommunicationPreferences = (
  options?: BaseMutationOptions<Data, Variables>
): BaseUseMutationResult<Data, Variables> => useBaseMutation(getCommunicationPreferences, options);

export const useGetCommunicationPreferencesQuery = (
  variables: Variables,
  options?: BaseQueryOptions<Data, Variables>
): BaseUseQueryResult<Data> => {
  return useBaseQuery<Data, Variables>(
    ["user", "communication", "methods"],
    getCommunicationPreferences,
    variables,
    options
  );
};
